import { useTraduccion } from '@tallerya/i18n';
import { Adjuntos } from '../../componentes/adjuntos/Adjuntos';
import { usePermisos } from '../../permisos/usePermiso';
import { useLineasOrden, type CabeceraOrden } from './datos';
import { nombreDe } from './SeccionTrabajo';

// La sección «Fotos» de la ficha (#140), como en `190:9042`: «Fotos · 4 fotos ·
// + Agregar» y las miniaturas, cada una con lo que retrata debajo.
//
// - **Es la galería de la orden**, con las fotos de sus líneas adentro: la API las
//   trae juntas y dice de qué línea es cada una. Debajo va el nombre de la línea, o
//   «De la orden» —el Figma dice «Ingreso»; se cambió para no suponer cuándo se
//   tomó—.
// - **«+ Agregar» sube a la orden en general.** La foto de una línea se sube desde
//   el «•••» de la línea, en «Trabajo»: no hay que elegirla de una lista.
// - Ver pide `order.view`; subir y quitar, `order.edit`. Sin él no hay «Agregar»
//   ni «×».

export function SeccionFotos({ orden }: { orden: CabeceraOrden }) {
  const { t } = useTraduccion();
  const { puede } = usePermisos();
  const id = String(orden.id);
  // Las mismas que dibuja «Trabajo»: ya están en la caché. Una línea quitada da de
  // baja sus fotos (#129), así que toda foto con línea encuentra su nombre.
  const lineas = useLineasOrden(id);
  const nombres = new Map((lineas.data ?? []).map((l) => [String(l.id), nombreDe(l)]));

  return (
    <section className="orden__seccion">
      <Adjuntos
        origen={{ tipo: 'orden', id }}
        titulo={t('admin.ordenes.fotos.titulo')}
        info={t('admin.ordenes.fotos.info')}
        conCuenta
        soloLectura={!puede('order.edit')}
        etiquetaDe={(a) => (a.detailId ? nombres.get(String(a.detailId)) : t('admin.ordenes.fotos.deLaOrden'))}
      />
    </section>
  );
}
